export default "__VITE_ASSET__1a5b88e2__"